'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logger = function (_Component) {
  _inherits(Logger, _Component);

  function Logger() {
    _classCallCheck(this, Logger);

    return _possibleConstructorReturn(this, (Logger.__proto__ || Object.getPrototypeOf(Logger)).apply(this, arguments));
  }

  _createClass(Logger, [{
    key: 'componentDidMount',

    /** @method componentDidMount
      * Binds the log function to the global vexpo object.
      */
    value: function componentDidMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      if (this.props.firebase && this.props.firebase.auth().currentUser) {
        var uid = this.props.firebase.auth().currentUser.uid;
        // Set up the logging reference for this user
        this.firebaseRef = this.props.firebase.database().ref('/log/' + uid);
        // Get the user's ip geodata and add it
        // to the attendee list entry
        fetch('https://freegeoip.net/json/').then(function (response) {
          return response.json();
        }).then(function (location) {
          _this2.props.firebase.database().ref('/location/' + uid).set(location);
        }).catch(function (err) {
          console.error(err);
        });
        // If the user came from a referred link, record the tag
        if (window.location.search) {
          var params = _querystring2.default.parse(window.location.search);
          if (params.refer) {
            this.props.firebase.database().ref('/referral/' + uid + '/' + params.refer).set(Date.now());
          }
        }
      }
      // Add the log method to the global vexpo object.
      window.vexpo.log = function (event) {
        if (_this2.firebaseRef) {
          _this2.firebaseRef.child(Date.now()).set(event);
        }
      };
    }
    /** @method render
      * The logger has no visual represntation.
      */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Logger;
}(_react.Component);

exports.default = Logger;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/logger/logger.js
// module id = 1091
// module chunks = 0